
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer id="contact" className="bg-stone-800 text-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-8 mb-12">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="/images/footer/footer-logo.svg"
                alt="Andhra Pradesh Government"
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-white">DTCP, Government of Andhra Pradesh</h3>
                <p className="text-sm text-stone-400">Directorate of Town & Country Planning</p>
              </div>
            </div>
            <p className="text-stone-300 leading-relaxed mb-6 max-w-md">
              Regulating urban development, approving building plans and layouts, preparing master plans,
              and ensuring planned growth of towns and cities across Andhra Pradesh.
            </p>
            <div className="flex items-center space-x-6">
              <a href="https://apcrda.org" className="text-xs text-stone-400 hover:text-amber-400 transition-colors">APCRDA</a>
              <a href="https://registration.ap.gov.in" className="text-xs text-stone-400 hover:text-amber-400 transition-colors">IGRS AP</a>
              <a href="https://meebhoomi.ap.gov.in" className="text-xs text-stone-400 hover:text-amber-400 transition-colors">MeeBhoomi</a>
              <a href="https://rera.ap.gov.in" className="text-xs text-stone-400 hover:text-amber-400 transition-colors">AP RERA</a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-stone-300 hover:text-amber-400 transition-colors">Home</a></li>
              <li><a href="/about" className="text-stone-300 hover:text-amber-400 transition-colors">About Us</a></li>
              <li><a href="/services" className="text-stone-300 hover:text-amber-400 transition-colors">Services</a></li>
              <li><a href="/resources" className="text-stone-300 hover:text-amber-400 transition-colors">Resources</a></li>
              <li><a href="/contact" className="text-stone-300 hover:text-amber-400 transition-colors">Contact Us</a></li>
              <li><a href="/privacy-policy" className="text-stone-300 hover:text-amber-400 transition-colors">Privacy Policy</a></li>
              <li><a href="/terms-of-service" className="text-stone-300 hover:text-amber-400 transition-colors">Terms of Service</a></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Contact Information</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-amber-400 mt-1"></i>
                <div className="text-stone-300 text-sm">
                  <div>Directorate of Town & Country Planning</div>
                  <div>Government of Andhra Pradesh</div>
                  <div>Mangalagiri, Guntur District</div>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-amber-400"></i>
                <div className="text-stone-300 text-sm">0863-2000662</div>
              </div>

              <div className="flex items-center space-x-3">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-amber-400"></i>
                <div className="text-stone-300 text-sm">dtcp-ap@gov.in</div>
              </div>

              <div className="flex items-center space-x-3">
                <i className="ri-global-line w-5 h-5 flex items-center justify-center text-amber-400"></i>
                <div className="text-stone-300 text-sm">dtcp.ap.gov.in</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-stone-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-stone-400">
              <div>&copy; 2026 DTCP, Government of Andhra Pradesh. All rights reserved.</div>
              <div className="flex items-center space-x-4">
                <a href="/accessibility" className="hover:text-amber-400 transition-colors">Accessibility</a>
                <a href="/sitemap" className="hover:text-amber-400 transition-colors">Sitemap</a>
              </div>
            </div>

            <div className="text-sm text-stone-400">
              Powered by <span className="text-amber-400 font-semibold">Dreamstep Software Innovations Pvt. Ltd.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
